import { checkIsUserCOARep } from 'helpers/utilCommon';
import { filter, find, forEach, isEmpty, isEqual, map } from 'lodash';
import React, { Component } from 'react';
import { Link } from "react-router-dom";

export default class LeftMenuLinks extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mainMenusLinks: [],
            memDashboardLinks: []
        };
    }

    componentDidMount() {
        const { customMenu } = this.props;
        this.prepareEntitlementList(customMenu);
    }

    componentDidUpdate(prevProps) {
        const { isMemberApp, activePath, entitlementList, userObj, customMenu } = this.props;
        if (!(prevProps.isMemberApp === isMemberApp &&
            prevProps.activePath === activePath &&
            isEqual(prevProps.entitlementList, entitlementList) &&
            isEqual(prevProps.userObj, userObj) &&
            isEqual(prevProps.customMenu, customMenu)
        )) {
            this.prepareEntitlementList(customMenu);
        }
    }

    isActivePath = (classname, url, isExact) => {
        let activeObj = {
            classname,
            selected: false
        };

        if (isEmpty(url)) return activeObj;

        const { activePath } = this.props;
        if (isExact) {
            if (activePath === url) {
                activeObj.classname = classname + ' active';
                activeObj.selected = true
            }
        } else {
            if (activePath.indexOf(url) === 0) {
                activeObj.classname = classname + ' active';
                activeObj.selected = true
            }
        }
        return activeObj
    }

    prepareEntitlementList(customMenu) {
        const { entitlementList, userObj, globalLinksURL } = this.props;

        // Only in case user is not logged in. In case of Customer/Non-Member, we still need to show global links
        if (isEmpty(userObj)) {
            return null;
        }

        let globalLinks = [{
            id: "G01",
            title: "MyAccount",
            url: isEmpty(globalLinksURL) ? "#" : globalLinksURL.profile ? globalLinksURL.profile : "#",
            isThirdPartyLink: true
        }, {
            id: "G02",
            title: "Membership",
            url: isEmpty(globalLinksURL) ? "#" : globalLinksURL.membership ? globalLinksURL.membership : "#",
        }, {
            id: "G03",
            title: "Orders",
            url: isEmpty(globalLinksURL) ? "#" : globalLinksURL.orders ? globalLinksURL.orders : "#",
            isThirdPartyLink: true
        }, {
            id: "G04",
            title: "Compass",
            url: isEmpty(globalLinksURL) ? "#" : globalLinksURL.compass ? globalLinksURL.compass : "#",
            isThirdPartyLink: true
        }, {
            id: "G05",
            title: "Tracker",
            url: isEmpty(globalLinksURL) ? "#" : globalLinksURL.tracker ? globalLinksURL.tracker : "#",
            isThirdPartyLink: true
        }];
        // Insert Student related links
        if (!isEmpty(entitlementList) && !isEmpty(entitlementList.otherInfo) &&
            entitlementList.otherInfo.membershipTypeDetails?.MembershipTypeId === 17 && 
            !(entitlementList.otherInfo.membershipTypeDetails?.MemberStatus.toLowerCase() === 'historical')) {
            globalLinks.splice(2, 0, {
                id: "G06",
                title: "Meetings & Symposia",
                url: isEmpty(globalLinksURL) ? "#" : globalLinksURL.meetingsSymposia ? globalLinksURL.meetingsSymposia : "#",
                isThirdPartyLink: true
            })
        }

        // Hide MyAccount Link in case of historical student member
        if (!isEmpty(entitlementList) && !isEmpty(entitlementList.otherInfo) &&
            entitlementList.otherInfo.membershipTypeDetails?.MembershipTypeId === 17 &&
            entitlementList.otherInfo.membershipTypeDetails?.MemberStatus.toLowerCase() === 'historical') {
            globalLinks = globalLinks.filter(links => links.id !== 'G01')
        }

        const { menuList } = entitlementList;
        let mainMenusLinks = [];
        let exposedMainMenuMappedList = [];
        forEach(globalLinks, (glink) => {
            const activeObj = this.isActivePath("nav-link", glink.url, true);
            if (this.props.isMainMenu) {
                mainMenusLinks.push({
                    id: glink.id,
                    classname: activeObj.classname,
                    selected: activeObj.selected,
                    path: glink.url,
                    title: glink.title,
                    isThirdPartyLink: glink.isThirdPartyLink
                });
            }
            let exposedMainMenuSubLink = [];
            const localLinks = find(menuList, { title: glink.title });
            if (!isEmpty(localLinks) && !isEmpty(localLinks.child)) {
                forEach(localLinks.child, (llink) => {
                    const activeObj = this.isActivePath("nav-link child", llink.url, true);
                    let title = llink.title;
                    let isThirdPartyLink = false;
                    let path = '';
                    if (llink.title === 'ASTM Campus') {
                        path = globalLinksURL.campus;
                        isThirdPartyLink = true;
                    } else {
                        path = isEmpty(llink.url) ? "#" : llink.url;
                    }
                    
                    if(checkIsUserCOARep(userObj?.memberType) && title === 'Reinstate Membership') {
                        return;
                    }else{
                        mainMenusLinks.push({
                            id: llink.id,
                            classname: activeObj.classname,
                            selected: activeObj.selected,
                            path,
                            title,
                            isThirdPartyLink
                        });
                        exposedMainMenuSubLink.push({ title: title, link: path });
                    }
                });
            }

            const customLinks = filter(customMenu, { parent: glink.title });
            if (!isEmpty(customLinks)) {
                forEach(customLinks, (clink) => {
                    const activeObj = this.isActivePath("nav-link child", clink.url, false);
                    let title = clink.title;
                    let path = isEmpty(clink.url) ? "#" : clink.url;
                    let obj = {
                        id: clink.id,
                        classname: activeObj.classname,
                        selected: activeObj.selected,
                        path,
                        title,
                        handleClick: clink.handleClick ? clink.handleClick : null
                    };
                    let exposedObj = { title: title, link: path, click: obj.handleClick };
                    if (isEmpty(clink.indexAt)) {
                        mainMenusLinks.push(obj);
                        exposedMainMenuSubLink.push(exposedObj);
                    } else {
                        const { indexAt } = clink;
                        mainMenusLinks.splice(indexAt[0], 0, obj);
                        exposedMainMenuSubLink.splice(indexAt[1], 0, exposedObj);
                    }
                });
            }

            let exposedMainMenuLink = { title: glink.title, link: glink.url };
            if (!isEmpty(exposedMainMenuSubLink)) {
                exposedMainMenuSubLink.unshift({ title: glink.title, link: glink.url });
                exposedMainMenuLink.subLinks = exposedMainMenuSubLink;
            }
            exposedMainMenuMappedList.push(exposedMainMenuLink);
        });

        let memDashboardLinks = [];
        const orgLinks = find(menuList, { title: 'Organization_Dashboard' });
        if (!isEmpty(orgLinks) && !isEmpty(orgLinks.child)) {
            forEach(orgLinks.child, (olink) => {
                const activeObj = this.isActivePath("nav-link", olink.url, false);
                memDashboardLinks.push({
                    id: olink.id,
                    classname: activeObj.classname,
                    selected: activeObj.selected,
                    path: isEmpty(olink.url) ? "#" : olink.url,
                    title: olink.title
                });
            });
        }

        this.setState({ mainMenusLinks, memDashboardLinks }, () => {
            this.props.getMenuMappedList({
                main: exposedMainMenuMappedList
            });
        });
    }

    renderLinks(linkObj) {
        const { isMemberApp, memberHost, entitlementList } = this.props;        
        if (linkObj.handleClick) {
            return (
                <a
                    key={linkObj.id}
                    id={linkObj.id}
                    className={linkObj.classname}
                    href='#'
                    data-toggle="pill"
                    aria-selected={linkObj.selected}
                    onClick={linkObj.handleClick}
                >{linkObj.title}</a>
            );
        }

        let disableStyle = {}
        if (linkObj.path === "#") {
            disableStyle = {
                opacity: 0.3,
                cursor: 'default'
            }
        };

        if (linkObj.isThirdPartyLink) {
            return <a
                key={linkObj.id}
                id={linkObj.id}
                style={disableStyle}
                className={linkObj.classname}
                data-toggle="pill"
                aria-selected={linkObj.selected}
                href={linkObj.path}
            >{linkObj.title}</a>
        }
        if (isMemberApp) {
            return (
                <Link
                    key={linkObj.id}
                    id={linkObj.id}
                    style={disableStyle}
                    className={linkObj.classname}
                    data-toggle="pill"
                    aria-selected={linkObj.selected}
                    to={linkObj.path}
                >{linkObj.title}</Link>
            );
        }
        return <a
            key={linkObj.id}
            id={linkObj.id}
            style={disableStyle}
            className={linkObj.classname}
            data-toggle="pill"
            aria-selected={linkObj.selected}
            href={memberHost ? memberHost + linkObj.path : linkObj.path}
        >{linkObj.title}</a>
    }

    render() {
        const { userObj, hideUserDetail } = this.props;
        const { mainMenusLinks, memDashboardLinks } = this.state;
        return (
            <>
                <div
                    className="nav flex-column astm-nav-tabs astm-nav-tabs--filters nav-pills"
                    id="v-pills-tab-indented"
                    role="tablist"
                    aria-orientation="vertical"
                >
                    {map(mainMenusLinks, (linkObj) => (this.renderLinks(linkObj)))}
                </div>

                <div className="solid-border mt24 mb24"></div>

                {isEmpty(memDashboardLinks) || true ? null : (
                    <>
                        <h6 className="astm-type-heading--h6 astm-type-heading--h6-bold">
                            {userObj.organizationName ? userObj.organizationName : "Member"} Dashboard
                        </h6>
                        <div
                            className="nav flex-column astm-nav-tabs astm-nav-tabs--filters nav-pills"
                            id="v-pills-tab-indented"
                            role="tablist"
                            aria-orientation="vertical"
                        >
                            {map(memDashboardLinks, (linkObj) => (this.renderLinks(linkObj)))}
                        </div>

                        <div className="solid-border mt24 mb24"></div>
                    </>
                )}
                {!hideUserDetail && userObj && Object.keys(userObj).length > 0 &&
                    <section className="sideBarNav">
                        {userObj.accountNumber ? (<p className="astm-type-body mb8">Account#: {userObj.accountNumber}</p>) : null}
                        {userObj.name ? (<p className="astm-type-body mb8">{userObj.name}</p>) : null}
                        {userObj.email ? (<p className="astm-type-body mb8">{userObj.email}</p>) : null}
                        {userObj.organizationName ? (<p className="astm-type-body mb8">{userObj.organizationName}</p>) : null}
                    </section>
                }
            </>
        )
    }
}
